import React from 'react';
import {withRouter} from 'react-router-dom';
import {Alert, Button, Dialog} from '@betareader/design-system';
import {withTranslation} from 'react-i18next';

import InActiveReadersList from './inactiveReadersList';
import NonStartersList from './nonStartersList';
import accessUtil from '../../../utils/accessUtil';
import AppIcon from '../../../components/AppIcon';

export const ReadingNotifications = ({
  inActiveReaders = [],
  nonStarters = [],
  location,
  history,
  access,
  t,
}) => {
  const show = new URLSearchParams(location.search).get('show');
  const readOnly = !accessUtil.isAllowed(access, ['edit']);
  if (!inActiveReaders.length && !nonStarters.length) return null;

  const setOpenDialog = dialog => {
    const params = new URLSearchParams(location.search);
    if (dialog) params.set('show', dialog);
    else params.delete('show');
    const search = params.toString();
    history.replace(`${location.pathname}${search ? `?${search}` : ''}`);
  };

  return (
    <Alert variant='info'>
      <ul style={{listStyle: 'none', margin: 0, padding: 0}}>
        {inActiveReaders.length > 0 && (
          <li>
            <Button variant='ghost' onClick={() => setOpenDialog('inActiveReaders')}>
              <AppIcon name='clock outline' aria-hidden='true' />
              {t('XReadersInactiveForYDays', {count: inActiveReaders.length, days: 7})}
              <span style={{textDecoration: 'underline'}}>{t('show')}</span>
            </Button>
            <Dialog open={show === 'inActiveReaders'} title={t('InactiveReaders')}
              onClose={() => setOpenDialog(null)}
              actions={<Button variant='secondary' onClick={() => setOpenDialog(null)}>
                {t('Close')}
              </Button>}>
              <InActiveReadersList readOnly={readOnly} readerEntries={inActiveReaders}
                onClose={() => setOpenDialog(null)} />
            </Dialog>
          </li>
        )}
        {nonStarters.length > 0 && (
          <li>
            <Button variant='ghost' onClick={() => setOpenDialog('nonStarters')}>
              <AppIcon name='clock outline' aria-hidden='true' />
              {t('XReadersNotStartedForYDays', {count: nonStarters.length, days: 7})}
              <span style={{textDecoration: 'underline'}}>{t('show')}</span>
            </Button>
            <Dialog open={show === 'nonStarters'}
              title={t('ReadersWhoHaveNotAcceptedTheInvitation')}
              onClose={() => setOpenDialog(null)}
              actions={<Button variant='secondary' onClick={() => setOpenDialog(null)}>
                {t('Close')}
              </Button>}>
              <NonStartersList readOnly={readOnly} readerEntries={nonStarters}
                onClose={() => setOpenDialog(null)} />
            </Dialog>
          </li>
        )}
      </ul>
    </Alert>
  );
};

export default withTranslation()(withRouter(ReadingNotifications));
